import React, { Component } from "react";
import Posts from "../../services/posts";
import MetaDecorator from "../../services/MetaDecorator";
import blog from "../../../media/images/blog.jpg";
import blogMobile from "../../../media/images/blogMobile.jpg";

let tagInstance = {};

export class Blog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
    };
  }

  componentDidMount = () => {
    let tabs = document
      .getElementsByClassName("nav-wrapper")[1]
      .querySelectorAll("ul")[0]
      .querySelectorAll("a");
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].removeAttribute("class");

      if (tabs[i].id === "blog") {
        tabs[i].setAttribute("class", "orange-text text-darken-4");
      }
    }

    let mobileTabs = document
      .getElementsByClassName("nav-wrapper")[1]
      .querySelectorAll("ul")[2]
      .querySelectorAll("a");
    for (let i = 0; i < mobileTabs.length; i++) {
      if (mobileTabs[i].id === "blogMobile") {
        mobileTabs[i].removeAttribute("class");
        mobileTabs[i].setAttribute(
          "class",
          "orange-text text-darken-4 grey darken-3"
        );
      }
    }

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  };

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 600;
    const isTablet = width <= 992 && width > 600;
    return (
      <React.Fragment>
        <MetaDecorator
          title="JetMinds | Blog"
          descrption="SharePoint Intranet, digitale Zusammenarbeit Beratung, ready-to-start Intranet mit den wichtigsten Funktionen und Diensten eines Intranets und vieles mehr"
          url="https://www.jetminds.de/blog/"
        />
        <div className="pageImageTitle">
          {isMobile ? (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={blogMobile}
              alt="JetMinds Blog"
              loading="lazy"
            />
          ) : (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={blog}
              alt="JetMinds Blog"
              loading="lazy"
            />
          )}
          {isMobile || isTablet ? (
            <div className="imgTxtMobile">
              <h1
                className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}
              >
                Tech-Knowledge
              </h1>
            </div>
          ) : (
            <div className="imgTxt">
              <h1 className="white-text">Tech-Knowledge</h1>
            </div>
          )}
        </div>
        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m12">
                <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"}`}>
                  Bleiben Sie{" "}
                  <span className="orange-text text-darken-4">up-to-date</span>{" "}
                  und erfahren Sie mehr über die{" "}
                  <span className="orange-text text-darken-4">modernen</span>{" "}
                  Technologien und die{" "}
                  <span className="orange-text text-darken-4">
                    Möglichkeiten
                  </span>{" "}
                  der digitalen Transformation
                </h1>
              </div>
            </div>
          </div>
          <Posts
            isTablet={isTablet}
            isMobile={isMobile}
            instance={tagInstance}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default Blog;



// WEBPACK FOOTER //
// ./src/components/layout/pages/Blog.js